import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import {
  MatButtonModule,
  MatDialogModule,
  MatIconModule,
  MatSnackBarModule,
  MatTooltipModule,
} from '@angular/material';
import { PreviewAuditDialogComponent } from './preview-audit-dialog.component';
import { EditAuditItemDialogModule } from '../edit-audit-item-dialog/edit-audit-item-dialog.module';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatSnackBarModule,
    MatTooltipModule,
    EditAuditItemDialogModule
  ],
  declarations: [PreviewAuditDialogComponent],
  entryComponents: [PreviewAuditDialogComponent],
  exports: [PreviewAuditDialogComponent]
})
export class PreviewAuditDialogModule {}



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/dialogs/preview-audit-dialog/preview-audit-dialog.module.ts